var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlockedIconWhite(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6964_49354",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 30,
    height: 30
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6964_49354)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.0139 26.9999C8.43883 27.0195 3.01751 21.6107 3.00004 15.0134C2.98258 8.43552 8.38746 3.01957 14.9861 3.00005C21.5632 2.98053 26.9794 8.38416 26.9999 14.9856C27.0205 21.5604 21.6136 26.9804 15.0139 26.9999ZM7.2132 21.1001C11.862 16.4588 16.4912 11.8349 21.1173 7.21611C17.5586 4.23076 11.6585 4.20816 7.8892 8.07802C4.14245 11.9232 4.34176 17.746 7.21423 21.1001H7.2132ZM8.83333 22.7284C12.427 25.7929 18.5736 25.8576 22.3841 21.6282C26.0507 17.56 25.3921 11.7681 22.7128 8.85364C18.0949 13.4703 13.4749 18.0871 8.8323 22.7274L8.83333 22.7284Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlockedIconWhite);
export default __webpack_public_path__ + "static/media/blocked_icon_white.607703f38989371257430024b62a7992.svg";
export { ForwardRef as ReactComponent };